var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "d-flex align-items-center" }, [
    _c("img", {
      staticClass: "mr-1",
      style: [_vm.isMobile ? { height: "15px" } : {}],
      attrs: {
        src: `${_vm.$s3}/img/common/global${_vm.white ? "_white" : ""}.svg?${
          _vm.$ver
        }`,
      },
    }),
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.lang,
            expression: "lang",
          },
        ],
        class: { my: _vm.save },
        attrs: { name: "lang" },
        on: {
          change: function ($event) {
            var $$selectedVal = Array.prototype.filter
              .call($event.target.options, function (o) {
                return o.selected
              })
              .map(function (o) {
                var val = "_value" in o ? o._value : o.value
                return val
              })
            _vm.lang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
          },
        },
      },
      _vm._l(_vm.$i18n.availableLocales, function (lang, i) {
        return _c("option", { key: i, domProps: { value: lang } }, [
          _vm._v("\n      " + _vm._s(_vm.localeNames?.[lang]) + "\n    "),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }